import CallToActionButton from '@/src/common/components/marketing/buttons/CallToActionButton'

const CtaButtons = () => (
    <div style={{ marginTop: 30 }}>
        <CallToActionButton
            url={'/corporate/get-started'}
            text={
                'Buying more than 50 cards or over $10,000 in load value? Talk to an Account Executive in minutes!'
            }
            gradientColor={'gradientBorderDefault'}
        />
        <CallToActionButton
            url={'/personalized-visa-gift-card'}
            text={
                'Want to customize each card and add a greeting card? Use our individual card building experience.'
            }
            gradientColor={'gradientBorderBlue'}
            header={'Individual Custom Visa Gift Cards'}
            customSVG={'/images/gradient_envelope.svg'}
        />
    </div>
)

export default CtaButtons
